import {
  Home,
  Users,
  FileText,
  CreditCard,
  BarChart2,
  Settings,
  BookOpen,
  ArrowRightLeft,
  Briefcase,
  Upload,
  DollarSign,
  Grid3X3,
  X,
  Menu
} from 'lucide-react';

import { useState } from 'react';
import { useNavigate } from "react-router-dom";

export default function BottomNavBar({ activeTab, setActiveTab }) {
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  // Get user role
  const userInfor = localStorage.getItem('userInfor') || '';
  const isSuperAdmin = userInfor === 'Super Admin';

  // SAME menuGroups from sidebar
  const menuGroups = [
    {
      title: 'General',
      items: [
        { name: 'Dashboard', icon: Home, path: '/DataCollectionDashboard', superAdminOnly: true },
      ],
    },
    {
      title: 'Data Collection',
      items: [
        { name: 'New Survey', icon: Users, path: '/DataCollection' },
        { name: 'Survey Dashboard', icon: Upload, path: '/DataCollectionDashboard' },
      ],
    },
    {
      title: 'Students',
      items: [
        { name: 'Students', icon: Users, path: '/students' },
        { name: 'Students Import', icon: Upload, path: '/BulkImport' },
      ],
    },
    {
      title: 'Fee Management',
      items: [
        { name: 'Invoices', icon: FileText, path: '/invoices' },
        { name: 'Fee Balance', icon: FileText, path: '/FeeBalance' },
        { name: 'Fee Voteheads', icon: BookOpen, path: '/Voteheads/Fee', superAdminOnly: true },
        { name: 'Payments', icon: CreditCard, path: '/payments' },
      ],
    },
    {
      title: 'Expense Management',
      items: [
        { name: 'Expenses', icon: DollarSign, path: '/expenses' },
        { name: 'Expense Voteheads', icon: BookOpen, path: '/Voteheads/Expense', superAdminOnly: true },
      ],
    },
    {
      title: 'Payroll',
      items: [
        { name: 'Salaries & Benefits', icon: Briefcase, path: '/salaries', superAdminOnly: true },
        { name: 'Payroll', icon: Settings, path: '/payroll', superAdminOnly: true },
      ],
    },
    {
      title: 'Financial Management',
      items: [
        { name: 'Petty Cash', icon: BookOpen, path: '/petty-cash', superAdminOnly: true },
        { name: 'Cash Transfer', icon: BookOpen, path: '/Transfer', superAdminOnly: true },
      ],
    },
    {
      title: 'Accounting Reports',
      items: [
        { name: 'Chart of Accounts', icon: BarChart2, path: '/chart-of-accounts', superAdminOnly: true },
        { name: 'Journal Entries', icon: BookOpen, path: '/journals', superAdminOnly: true },
        { name: 'Trial Balances', icon: ArrowRightLeft, path: '/trial-balance', superAdminOnly: true },
      ],
    },
  ];

  // Filter based on role
  const filteredMenuGroups = menuGroups.map(group => ({
    ...group,
    items: group.items.filter(item => !item.superAdminOnly || isSuperAdmin)
  }));

  // Flatten into one list for grid
  const premiumMenuItems = filteredMenuGroups
    .flatMap(group => group.items)
    .map(item => ({
      label: item.name,
      path: item.path,
      icon: <item.icon size={24} />,
      color: 'bg-blue-600' // you can randomize later if you want
    }));

  // Bottom nav
  const navItems = [
    { name: 'Home', icon: <Home size={22} />, key: 'home', path: '/DataCollectionDashboard' },
    { name: 'Students', icon: <Users size={22} />, key: 'students', path: '/students' },
    { name: 'Invoices', icon: <FileText size={22} />, key: 'invoices', path: '/invoices' },
    { name: 'Menu', icon: <Grid3X3 size={22} />, key: 'menu' },
  ];

  const handleNavClick = (item) => {
    if (item.key === 'menu') {
      setShowModal(true);
    } else {
      navigate(item.path);
      setActiveTab(item.key);
    }
  };

  const handleMenuItemClick = (path) => {
    navigate(path);
    setShowModal(false);
  };

  return (
    <>
      {/* Bottom Bar */}
      <div className="fixed md:hidden bottom-0 left-0 right-0 z-50 bg-white border-t shadow-lg">
        <div className="flex justify-around items-center h-16">
          {navItems.map(item => (
            <button
              key={item.key}
              onClick={() => handleNavClick(item)}
              className={`flex flex-col items-center text-xs ${
                activeTab === item.key ? 'text-blue-600' : 'text-gray-600'
              }`}
            >
              {item.icon}
              <span>{item.name}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 z-50 bg-white">
          
          {/* Header */}
          <div className="flex justify-between p-4 border-b">
            <h2 className="font-bold text-lg">All Features</h2>
            <button onClick={() => setShowModal(false)}>
              <X size={26} />
            </button>
          </div>

          {/* Grid */}
          <div className="p-4 overflow-y-auto" style={{ height: 'calc(100vh - 70px)' }}>
            <div className="grid grid-cols-2 gap-4">
              {premiumMenuItems.map((item, index) => (
                <button
                  key={index}
                  onClick={() => handleMenuItemClick(item.path)}
                  className="p-4 border rounded-xl hover:shadow-md transition"
                >
                  <div className={`w-12 h-12 flex items-center justify-center text-white rounded-lg mb-2 ${item.color}`}>
                    {item.icon}
                  </div>
                  <div className="text-sm font-medium">{item.label}</div>
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}